<div class="carousel-item">
  <div class="carousel-item__gallery">
    <nz-carousel [nzEffect]="'fade'">
      <div
        *ngFor="let image of images"
        nz-carousel-content
        class="slide-item"
      >
        <img
          [src]="image.src"
          [alt]="image.title"
          class="slide-item__image"
        />

        <div class="slide-item__wrapper">
          {{ image.title }}
        </div>
      </div>
    </nz-carousel>
  </div>

  <div class="carousel-item__controls">
    <span
      class="arrow arrow--prev"
      (click)="goToPrev()"
    >
      <i
        nz-icon
        nzType="left"
        nzTheme="outline"
      ></i>
    </span>
    <span
      class="arrow arrow--next"
      (click)="goToNext()"
    >
      <i
        nz-icon
        nzType="right"
        nzTheme="outline"
      ></i>
    </span>
  </div>
</div>
